export const FETCH_SHOP_BY_PET_REQUEST = 'FETCH_SHOP_BY_PET_REQUEST';
export const FETCH_SHOP_BY_PET_SUCCESS = 'FETCH_SHOP_BY_PET_SUCCESS';
export const FETCH_SHOP_BY_PET_FAILURE = 'FETCH_SHOP_BY_PET_FAILURE';
